// extracted by mini-css-extract-plugin
export default {"container":"PricingPlan_container__x1LKD","header":"PricingPlan_header__WwEy9","desc":"PricingPlan_desc__uS6+k","selected":"PricingPlan_selected__LQkHn"};